@if (!loaded) {
  <p-skeleton height="4rem" styleClass="mb-2" />
} @else {
  <form [formGroup]="formGroup" class="flex flex-col gap-4" (ngSubmit)="onSubmit()">

    <div class="flex gap-2 w-full">
      <div class="flex flex-col gap-2 w-full">
        <label for="date"> Datum </label>
        <p-datepicker [iconDisplay]="'input'"
                      [firstDayOfWeek]="1"
                      placeholder="Datum auswählen"
                      [showIcon]="true"
                      inputId="date"
                      formControlName="date"
                      styleClass="w-full"
                      dateFormat="dd.mm.yy" />
      </div>

      <div class="flex flex-col gap-2 w-full">
        <label for="time"> Uhrzeit </label>
        <p-datepicker [iconDisplay]="'input'"
                      [showIcon]="true"
                      [timeOnly]="true"
                      placeholder="Uhrzeit auswählen"
                      inputId="time"
                      formControlName="time"
                      styleClass="w-full"
                      inputStyleClass="w-full" />
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label for="rabbit"> Kaninchen </label>
      @if (rabbits$ | async; as rabbits) {
        <p-select
          [options]="rabbits"
          placeholder="Kaninchen auswählen"
          formControlName="rabbit"
          inputId="rabbit"
          styleClass="w-full">
          <ng-template let-rabbit #item>
            <div class="flex items-center gap-2">
                @if (rabbit.isDisabled) {
                  <ng-icon name="gameSightDisabled" />
                }
                <div>{{ rabbit.name }}</div>
            </div>
          </ng-template>
          <ng-template let-rabbit #selectedItem>
            <div class="flex items-center gap-2">
                @if (rabbit.isDisabled) {
                  <ng-icon name="gameSightDisabled" />
                }
                <div>{{ rabbit.name }}</div>
            </div>
          </ng-template>
        </p-select>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="medicines"> Medizin </label>
      @if (medicines$ | async; as medicines) {
        <p-multiSelect
          [options]="medicines"
          [showToggleAll]="false"
          [showHeader]="false"
          [autoOptionFocus]="false"
          [filter]="false"
          [showClear]="true"
          [maxSelectedLabels]="medicines.length"
          optionLabel="abbreviation"
          formControlName="medicines"
          inputId="medicines"
          placeholder="Medizin auswählen"
          display="chip"
          styleClass="w-full">
          <ng-template let-medicine pTemplate="item">
            {{ medicine.name }} ({{ medicine.abbreviation }})
          </ng-template>
        </p-multiSelect>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label for="weight"> Gewicht </label>
      <p-inputGroup>
        <input id="weight" placeholder="Gewicht eingeben" type="number" min="1" pInputText formControlName="weight" />
        <p-inputGroupAddon>g</p-inputGroupAddon>
      </p-inputGroup>
    </div>

    <div class="flex flex-col gap-2">
      <label for="comment"> Kommentar </label>
      <input pInputText id="comment" placeholder="Kommentar eingeben" type="text" formControlName="comment"
             class="w-full" />
    </div>

    <div class="flex gap-2">
      <p-button type="button" label="Abbrechen" (click)="navigateToOverviewPage()" severity="warn" />
      <p-button type="submit" label="Abschicken" [pTooltip]="(isSelectedRabbitDisabled$ | async) ? 'Kaninchen ist deaktiviert' : undefined" severity="success" [disabled]="(isSubmitDisabled$ | async)" />
    </div>

  </form>
}
